module.exports = __webpack_public_path__ + "img/mob_top_img1.0b6c481c.png";